import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, Res } from 'src/app/models';
import { ApiReferencesService, NotificationService, ValidatorsService, DatetimeService, LanguageService, ApiAttributesGroupsService, PermissionService, ApiOrganizationsService } from 'src/app/services';
import { AttributesGroupsActionsValidator } from './attributes-groups-actions.validator';

@Component({
  selector: 'app-attributes-groups-actions',
  templateUrl: './attributes-groups-actions.component.html',
  styleUrls: ['./attributes-groups-actions.component.css']
})
export class AttributesGroupsActionsComponent implements OnInit {

  attributeId: string;
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  groupName: Lang;
  editData:any;
  organizations: any[] = [];
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  @Input() set data(value) {

    console.log("VALUE: ", value);
    

    if (value != null) {
      this.attributeId = value.group_id;
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    org_id: [null],
    name: [null, Validators.required]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private apiAttrGroupService: ApiAttributesGroupsService,
    private notification: NotificationService,
    private validatorService: ValidatorsService,
    private validator: AttributesGroupsActionsValidator,
    public permissionAccess: PermissionService,
    private apiOrganozations: ApiOrganizationsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    if(this.permissionAccess.check('REFERENCES_ORGANIZATIONS')){
      this.getOrganizations();
    }

    if (this.attributeId) {

      this.onEdit();

    }


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }
  
  /**
   * 
   * @param referenceData 
   */
  setDataInForm(groupData) {

    this.groupName = groupData.name;

    if(this.attributeId){

      this.form.get('org_id').disable();
    }

    this.form.patchValue({
      id: groupData.id,
      org_id: groupData.org_id
    });
  }

  /**
   * 
   */
   getOrganizations(searchValue: string = ''): void {

    this.organizations = [];

    let data = {
      ref_name: 'organizations',
      filter: {
        name: searchValue,
        sort: 'all'
      }
     }

    this.subscriptions.add(
      this.apiOrganozations.getReferences(data, data.ref_name).subscribe((response: Res) => { console.log('[RESPONSE] getOrganizations: ', response);

        if(response != null){

          this.organizations = response.result;
          
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiAttrGroupService.edit(this.attributeId).subscribe((response: Res) => {
        console.log('[RESPONSE] GROUP_EDIT_DATA: ', response);

        if (response != null) {

          this.editData = response.result;
          this.setDataInForm(response.result);
          this.organizations.push({id: this.editData.org_id, name: this.editData.org_name})
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttrGroupService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] saveReference: ', response);

        if (response != null) {

          this.notification.show('success', 'Группа атрибутов успешно создана!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
   onUpdate() {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttrGroupService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
   validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
